<template>
  <q-list>
    <q-item-wrapper
      icon="mdi-account-outline"
      label="Who is this appointment for?"
      label-class="text-subtitle2"
      dense
      class="q-mb-sm invisible-item"
    />

    <q-item-label
      v-if="!canAlterReminders"
      header
      class="text-red-7"
    >
      Reminders for this appointment cannot be modified
    </q-item-label>

    <q-item-label
      v-if="event.clients.length > 0 && canAlterReminders && event.status === 'UNSCHEDULED' && !company.appointments_send_client_unscheduled_reminders"
      header
      class="text-red-7"
    >
      Automatic client reminders are disabled for unscheduled appointments
    </q-item-label>

    <div class="q-px-md">
      <client-input-popover
        ref="popover"
        :model-value="event.clients"
        outlined
        dense
        icon="mdi-magnify"
        placeholder="Find Clients..."
        multiple
        with-phones="ALL"
        with-addresses="ALL"
        hide-selected
        :hide-on-first-click="event.clients.length < 1"
        :can-create="can(permissions.canAccessClients)"
        @clicked-result="addClient"
        @removed-result="removeClient"
      />
    </div>

    <tip
      name="moduleAppointmentsReminders"
      wrapper-class="q-px-md q-py-sm"
      :inline-actions="false"
    >
      <q-item-label class="text-bold">
        How do Reminders work?
      </q-item-label>
      <q-item-label>
        Learn how to effectively use Reminders for your clients & staff.
      </q-item-label>

      <template #action>
        <q-btn
          no-caps
          color="white"
          size="12px"
          text-color="black"
          label="Learn More"
          @click="$bus.emit('help:search', 'reminders')"
        />
      </template>
    </tip>

    <q-list
      v-if="event.clients.length > 0"
      padding
      class="q-gutter-xl"
    >
      <ClientRemindersList
        v-for="(client, key) in event.clients"
        :key="key"
        :event="event"
        :client="client"
        :can-alter-reminders="canAlterReminders"
        :reminders="event.client_reminders.filter(item => item.client_id === client.id)"
        @remove-client="removeClient(client)"
      />
    </q-list>

    <q-item-wrapper v-if="willSendSMS">
      <SmsChargeWarning />
      <SandboxSmsNotice v-if="isDevelopment" />
    </q-item-wrapper>
  </q-list>
</template>

<script>
import fillClientDetailsMixin from '../../mixins/fillClientDetailsMixin'
import ClientRemindersList from './partials/ClientRemindersList'
import SandboxSmsNotice from 'components/partials/sandbox/SandboxSmsNotice'
import SmsChargeWarning from 'components/partials/communications/SmsChargeWarning'

export default {
  components: {
    ClientRemindersList, SandboxSmsNotice, SmsChargeWarning
  },
  mixins: [fillClientDetailsMixin],
  props: {
    event: {
      required: true,
      type: Object
    },
    canAlterReminders: {
      type: Boolean,
      default: true
    },
    withoutClient: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      isDevelopment: !!process.env.SANDBOX
    }
  },
  computed: {
    willSendSMS () {
      return this.event.client_reminders.filter(item => item.type === 'SMS').length > 0
    }
  },
  methods: {
    addClient (val) {
      this.baseAddClient(this.event, val)
    },
    removeClient (client) {
      this.baseRemoveClient(this.event, client)
    }
  },
  mounted () {
    if (this.event.clients.length < 1) {
      this.timed(() => {
        if (!this.$refs.popover) {
          return
        }
        this.$refs.popover.focus()
      }, this.$q.platform.is.mobile ? 750 : 500)
    }
  }
}
</script>
